import { useState, useEffect, useRef } from 'react';
import { getSpeechOrchestrator } from '../Voice/SpeechOrchestrator';
import { v4 as uuidV4 } from 'uuid';
/**
 * useChatbotState - Hook to manage chatbot state
 * @public
 */
export const useChatbotState = props => {
  const {
    submitChatMessagesPayload,
    setiValues,
    speechFetchRequestOptions,
    debugMode,
    componentVersion
  } = props;
  const telemetrySessionIdPart = uuidV4();
  const telemetrySessionId = submitChatMessagesPayload.cguid ? `${submitChatMessagesPayload.cguid}-${telemetrySessionIdPart}` : submitChatMessagesPayload.rguid;
  const [loadMoreMessages, setLoadMoreMessages] = useState(false);
  const [lastPromptId, setLastPromptId] = useState('');
  const speechOrchestratorRef = useRef(null);
  const audioPlayerRef = useRef(null);
  // Initialize Speech Orchestrator if voice is enabled
  useEffect(() => {
    if (setiValues === null || setiValues === void 0 ? void 0 : setiValues.enableVoice) {
      speechOrchestratorRef.current = getSpeechOrchestrator((speechFetchRequestOptions === null || speechFetchRequestOptions === void 0 ? void 0 : speechFetchRequestOptions.url) || '/genai-svc/genai/speech', (speechFetchRequestOptions === null || speechFetchRequestOptions === void 0 ? void 0 : speechFetchRequestOptions.timeout) || 10000, audioPlayerRef.current, debugMode);
      return () => {
        speechOrchestratorRef.current = null;
      };
    }
  }, [setiValues, speechFetchRequestOptions, debugMode]);
  return {
    telemetrySessionId,
    audioPlayerRef,
    speechOrchestratorRef,
    loadMoreMessages,
    setLoadMoreMessages,
    lastPromptId,
    setLastPromptId,
    componentVersion
  };
};